import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAnalytics } from "../context/AnalyticsProvider";

export const usePageTracking = () => {
  const location = useLocation();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [trackPageView, location]);
}
